<template>
  <EkycWaiting data-fn-location="ekyc-waiting" />
</template>

<script>
import EkycWaiting from '../components/templates/EkycWaiting'

export default {
  metaInfo: {
    title: 'กำลังตรวจสอบ eKYC - Finnomena'
  },
  components: {
    EkycWaiting
  }
}
</script>
